"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguageCodeByLanguageName = exports.getLanguageNameByLanguageCode = void 0;
var locale_1 = require("../locale");
var isKeyInObject_1 = require("./isKeyInObject");
var T = {
    UNKNOWN: function (input) { return "unknown language ".concat(input); },
};
/**
 * Helper to get the `languageName` of a language by providing the `languageCode`.
 *
 * @example
 * // returns 'Deutschland'
 *  getLanguageNameByLanguageCode('DE')
 *
 * @param languageCode
 */
var getLanguageNameByLanguageCode = function (languageCode) {
    var languageKey = Object.keys(locale_1.languages).find(function (language) {
        return (0, isKeyInObject_1.isKeyInObject)(locale_1.languages, language)
            ? locale_1.languages[language].languageCode === languageCode
            : false;
    });
    return languageKey && (0, isKeyInObject_1.isKeyInObject)(locale_1.languages, languageKey)
        ? locale_1.languages[languageKey].languageName
        : T.UNKNOWN(languageCode);
};
exports.getLanguageNameByLanguageCode = getLanguageNameByLanguageCode;
/**
 * Helper to get the `languageCode` of a language by providing the `languageName`.
 *
 * @example
 * // returns 'DE'
 *  getLanguageNameByLanguageCode('Deutschland')
 *
 * @param languageCode
 */
var getLanguageCodeByLanguageName = function (languageName) {
    var languageKey = Object.keys(locale_1.languages).find(function (language) {
        return (0, isKeyInObject_1.isKeyInObject)(locale_1.languages, language)
            ? locale_1.languages[language].languageName === languageName
            : false;
    });
    return languageKey && (0, isKeyInObject_1.isKeyInObject)(locale_1.languages, languageKey)
        ? locale_1.languages[languageKey].languageCode
        : T.UNKNOWN(languageName);
};
exports.getLanguageCodeByLanguageName = getLanguageCodeByLanguageName;
